<script>
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  data() {
    return {
      provinceOfficeLevel: -1 // 省级分公司层级
    }
  },
  computed: {
    // 是否可以进行区域内委托
    isRegionalCommission() {
      return this.provinceOfficeLevel >= 0 && this.$store.getters.currentOfficeLevel >= this.provinceOfficeLevel && this.$checkPermission(['roleGroup_Common_regionalCommission'])
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      immediate: true,
      async handler() {
        await cache.load(cacheName.CONFIG)
        this.provinceOfficeLevel = Number(cache.config.get('RegionalCommission'))
      }
    }
  }
}
</script>
